<template>
    <div>

        <div v-if="editAgenda && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitCalendarioAgenda" v-if="!editAgenda || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editAgenda || dados.id">

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>DATA</th>
                            <th>QTD MATUTINO</th>
                            <th>QTD VESPERTINO</th>
                            <th>QTD NOTURNO</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in dados.datas" :key="i">
                            <td>
                                <el-date-picker                                 
                                    class="date-picker-matricula"
                                    v-model="dados.datas[i].data" 
                                    type="date"                                  
                                    format="dd/MM/yyyy" 
                                    value-format="yyyy-MM-dd"
                                    style="width: 100%;"
                                ></el-date-picker>
                            </td>
                            <td style="width: 200px;">
                                <b class="hidden-desktop">QTD MATUTINO:</b>
                                <el-input v-model="dados.datas[i].vagas_totais_matutino" maxlength="191"></el-input>
                            </td>
                            <td style="width: 200px;">
                                <b class="hidden-desktop">QTD VESPERTINO:</b>
                                <el-input v-model="dados.datas[i].vagas_totais_vespertino" maxlength="191"></el-input>
                            </td>
                            <td style="width: 200px;">
                                <b class="hidden-desktop">QTD NOTURNO:</b>
                                <el-input v-model="dados.datas[i].vagas_totais_noturno" maxlength="191"></el-input>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <div class="u-text-right">
                            <el-button @click="adicionarLinhaData()" type="primary" plain>
                                <i class="fas fa-plus"></i> ADICIONAR DATA
                            </el-button>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-salvar" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {  
    props: ['paramId'],  
    data: () => ({
        editAgenda: false,
        alert: false,
        dados: {
            datas: [],                       
        }

    }),
    mounted () {

    },
    methods:{
        adicionarLinhaData(){

            this.dados.datas.push({ data: '', vagas_totais_matutino: '', vagas_totais_vespertino: '', vagas_totais_noturno: '' });
        },        
        onSubmitCalendarioAgenda(){

            document.getElementById("btn-salvar").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true); 
                
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/pre-matricula/storeCalendarioAgenda`, this.dados.datas, this.$store.getters.getHeaderAuth).then(response => {
                     
                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.$emit('onSubmitCalendarioAgenda');
                }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });                

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },       
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    }    
}
</script>
